import React from 'react';
import Grid from '@mui/material/Grid';
import { ChartOptions, ChartData } from 'chart.js';
import GenericChart from 'src/components-dummy/Chart/Chart';
import { ChartType } from '../../types';
import { Box } from '@mui/material';

export interface BarChartProps {
  data: ChartData<'bar'>;
  options?: ChartOptions<'bar'>;
  width?: string;
  height?: string;
}

export default function BarChart({
  data,
  options,
  width = '100%',
  height = '400px',
}: BarChartProps): JSX.Element {
  return (
    <Box sx={{ width: '100%', maxWidth: '100vw', overflowX: 'auto' }}>
      <Grid container justifyContent='center' direction={'column'}>
        <Grid item sx={{ width: '100%' }}>
          <GenericChart
            type={ChartType.Bar}
            data={data}
            options={options}
            width={width}
            height={height}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
